import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AppShell } from '@/components/layout/AppShell';
import { PageContainer } from '@/components/layout/PageContainer';
import { TopBar } from '@/components/layout/TopBar';
import { Card } from '@/components/ui/Card';
import { Button } from '@/components/ui/Button';
import { Spinner } from '@/components/ui/Spinner';
import { useSubscriptionPlans } from '@/api/queries/subscription';
import { centsToUsdString } from '@/utils/money';
import { useLocale } from '@/hooks/useLocale';
import { paths } from '@/routes/paths';

export function SubscribePlansPage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { locale } = useLocale();
  const plans = useSubscriptionPlans(true);

  return (
    <AppShell>
      <PageContainer>
        <TopBar back title={t('subscribe.title')} />
        {plans.isLoading && <Spinner />}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {(plans.data ?? []).map((p) => (
            <Card key={p.code} variant="light" padding="md">
              <div style={{ fontWeight: 600, fontSize: 18 }}>{t(p.name_key ?? p.code, { defaultValue: p.code })}</div>
              <div style={{ fontSize: 24, fontWeight: 700, marginBlock: 6 }}>
                {centsToUsdString(p.amount_cents, locale)}
                <span style={{ fontSize: 14, fontWeight: 500, opacity: 0.7 }}>
                  {' '}/{p.period === 'annual' ? 'yr' : 'mo'}
                </span>
              </div>
              <Button
                block
                variant="primary"
                onClick={() => navigate(paths.subscribePayment(p.code))}
              >
                {t('subscribe.buy_for', { price: centsToUsdString(p.amount_cents, locale) })}
              </Button>
            </Card>
          ))}
        </div>
      </PageContainer>
    </AppShell>
  );
}
